import { IconStarFilled } from "@tabler/icons-react";
import styles from "./styles.module.scss";

export function StoreStars({ tone = "gold" }: { tone?: "gold" | "brown" }) {
  return (
    <span className={`${styles.stars} ${tone === "brown" ? styles.brown : ""}`} role="img" aria-label="Avaliação 5 de 5 estrelas">
      {Array.from({ length: 5 }, (_, index) => <IconStarFilled key={index} aria-hidden="true" />)}
    </span>
  );
}
